import { ApisClient } from "@dpdgroupuk/mydpd-app";

// eslint-disable-next-line no-restricted-globals
export const getEnvFromSubDomain = () => location.hostname.split("-").shift();

export default new ApisClient({
  fallbackBaseUrl: process.env.REACT_APP_TARGET_PROXY_APIS,
});
